import { createTheme } from '@mui/material/styles';

// global theme for all components - this is tbd
const theme = createTheme({
    typography: {
        fontFamily: ['Arial', 'sans-serif'],
        useNextVariants: true,
        h1: {
            color: '#002677', // optum dark blue
            fontSize: '2em',
            fontWeight: 500,
        },
        body1: {
            color: '#5A5A5A', // optum dark gray
        },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                'background-color': '#002677',
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: '#db3131',
                    '&$error': {
                        color: '#db3131',
                    },
                },
            },
        },
    },
});

export default theme;
